/**************************************************
 * Nombre:       Tarjeta_Evento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {CalendarMonth} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Evento = ({item}) => {
    const {sCell, masSM, sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                border: 1,
                borderColor: '#fff',
                borderRadius: 6,


            }}
        >


            <Grid container size={{xs: 12, sm: 6, md: 5}}
                  sx={{justifyContent: 'flex-start', borderRight: sCell ? 0 : 2, borderColor: '#fff',}}>
                <img src={item.img} width={'100%'} height={'auto'}
                     style={{
                         borderTopLeftRadius: 24,
                         borderBottomLeftRadius: sCell ? 0 : 24,
                         borderTopRightRadius: sCell ? 24 : 0
                     }}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 6, md: 7}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        px: 6,

                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                        <Typography sx={{
                            fontFamily: NEGRITA,
                            fontSize: sTab ? 24 : 32,
                            fontWeight: 600,
                            lineHeight: 1.1,
                            textAlign: sCell ? 'center' : 'left'
                        }}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{
                            fontSize: sTab ? 12 : 16,
                            fontWeight: 400,
                            textAlign: sCell ? 'center' : 'left'
                        }}>{item.descripcion}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{fontWeight: 600}}>
                            <span>
                                <CalendarMonth sx={{mt: 0.5, mb: -0.5, pr: 1}}/>
                            </span>
                            {item.fecha}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 4, mb: sCell ? 6 : 0}}>
                        <Button color={'info'} sx={{fontSize: 14}}>
                            MAS INFORMACION
                        </Button>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Evento